import React, { Component } from "react";
import "../../App.css";
import { getTargets, getHoldings, updateTarget } from "../../Api/Http";
import targetsConfig from "../../config/targets.json";
import defaultConfig from "../../config/default.json";
import {
    sort,
    createObjectOnBehalfOfGivenKey,
    getHoldingNetPercentChange,
    roundOff,
    executeFunction,
} from "../../Utils/utils";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

class Targets extends Component {
    async componentDidMount() {
        let getHoldingsResp = await getHoldings();
        const holdingsObject = createObjectOnBehalfOfGivenKey({
            arr: getHoldingsResp,
            key: "tradingsymbol",
        });
        const updateStateTargets = async () => {
            const getTargetsResp = await getTargets();
            const resp = getTargetsResp.map(value => {
                const netPercentChange =
                    (holdingsObject[value.tradingsymbol] &&
                        getHoldingNetPercentChange({
                            data: holdingsObject[value.tradingsymbol],
                        })) ||
                    0;
                value.netPercentChange = netPercentChange;
                value.breakout = roundOff(parseFloat(value.percent) - netPercentChange);
                value.netPercentChange = netPercentChange;
                value.jump = value.jumpPercent;
                value.dayChangePercentage =
                    holdingsObject[value.tradingsymbol] &&
                    roundOff(holdingsObject[value.tradingsymbol].day_change_percentage);
                return value;
            });
            this.setState({ getMappedTargetsResp: resp });
            this.setState({ targetsCount: resp.length });
            return resp;
        };
        let getMappedTargetsResp = await updateStateTargets();

        const setDefaultVisibilityOfColumns = () => {
            const obj = {};
            for (const iterator of Object.keys(targetsConfig.page.columns)) {
                if (!obj[iterator]) {
                    obj[iterator] = {};
                }
                for (const orderIterator of Object.keys(defaultConfig.order.type)) {
                    if (defaultConfig.order.type.ascending === orderIterator) {
                        obj[iterator][orderIterator] = true;
                    } else {
                        obj[iterator][orderIterator] = false;
                    }
                }
            }
            return obj;
        };

        const ordering = async ({ key, type }) => {
            if (type === defaultConfig.order.type.ascending) {
                this.state.visibility[key][defaultConfig.order.type.descending] = true;
                getMappedTargetsResp = sort({ data: getMappedTargetsResp, key, type });
            }
            if (type === defaultConfig.order.type.descending) {
                this.state.visibility[key][defaultConfig.order.type.ascending] = true;
                getMappedTargetsResp = sort({ data: getMappedTargetsResp, key, type });
            }
            this.state.visibility[key][type] = !this.state.visibility[key][type];
            this.setState({ getMappedTargetsResp: getMappedTargetsResp });
            this.setState({ visibility: this.state.visibility });
        };

        const onClickOfTargetUpdate = async ({ value, index, array }) => {
            let shouldMakeCall = false;
            for (const key in this.state.updatedValues[value.id]) {
                if (this.state.updatedValues[value.id][key] !== undefined) {
                    if (value[key] !== this.state.updatedValues[value.id][key]) {
                        shouldMakeCall = true;
                        value[key] = this.state.updatedValues[value.id][key];
                    }
                }
            }
            if (shouldMakeCall) {
                await executeFunction({ reference: updateTarget, body: value });
            }
            this.setState({ getMappedTargetsResp: array });
        };

        this.setState({ holdingsObject: holdingsObject });
        this.setState({ visibility: setDefaultVisibilityOfColumns() });
        this.setState({ onClickOfTargetUpdate: onClickOfTargetUpdate });
        this.setState({ updatedValues: {} });
        this.setState({ ordering: ordering });
    }
    render() {
        let getMappedTargetsResp;
        if (this.state && this.state.getMappedTargetsResp && this.state.getMappedTargetsResp) {
            //headers
            getMappedTargetsResp = [
                <div>
                    <tr>
                        {Object.keys(targetsConfig.page.columns).map(value => (
                            <th className="triggers-table-columns-heading-target">
                                {targetsConfig.page.columns[value].name}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["ascending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.ordering({
                                                    data: this.state.getMappedTargetsResp,
                                                    key: value,
                                                    type: defaultConfig.order.type.ascending,
                                                })
                                            }>
                                            &#9650;
                                        </button>
                                    )}
                                {this.state.visibility &&
                                    this.state.visibility[value] &&
                                    this.state.visibility[value]["descending"] && (
                                        <button
                                            onClick={() =>
                                                this.state.ordering({
                                                    data: this.state.getMappedTargetsResp,
                                                    key: value,
                                                    type: defaultConfig.order.type.descending,
                                                })
                                            }>
                                            &#9660;
                                        </button>
                                    )}
                            </th>
                        ))}
                    </tr>
                </div>,
            ];
            //data
            getMappedTargetsResp.push(
                ...this.state.getMappedTargetsResp.map((value, index, array) => (
                    <div id={value.id}>
                        <tr>
                            <td className="triggers-table-rows-target">
                                <span>{value.tradingsymbol}</span>
                                <span>({value.netPercentChange}%)</span>
                            </td>
                            <td className="triggers-table-rows-can-sell">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    type="checkbox"
                                    trigger={<button> {value.canSell} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box-session-count"
                                            type="checkbox"
                                            defaultChecked={value.canSell}
                                            onChange={event => {
                                                const updatedValues = this.state.updatedValues;
                                                if (updatedValues) {
                                                    if (!updatedValues[value.id]) {
                                                        updatedValues[value.id] = {};
                                                    }
                                                    updatedValues[value.id].canSell = event.target.checked;
                                                    this.setState({ updatedValues: updatedValues });
                                                    this.state.onClickOfTargetUpdate({ value, index, array });
                                                }
                                                return;
                                            }}></input>
                                    </div>
                                </Popup>
                            </td>

                            <td className="triggers-table-rows-target">
                                <Popup
                                    key={value.id + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.percent || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.id + "_input"}
                                            className="target-input-box-session-count"
                                            type="text"
                                            defaultValue={value.percent || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.id]) {
                                                            updatedValues[value.id] = {};
                                                        }
                                                        updatedValues[value.id].percent = event.target.value;
                                                        this.setState({ updatedValues: updatedValues });
                                                    }
                                                }
                                                return;
                                            }}></input>
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfTargetUpdate({ value, index, array })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>
                            <td className="triggers-table-rows">
                                <Popup
                                    key={value.tradingsymbol + "_popup"}
                                    closeOnDocumentClick
                                    disabled={false}
                                    trigger={<button> {value.note || "-"} </button>}
                                    position="center center">
                                    <div>
                                        <input
                                            key={value.tradingsymbol + "_input"}
                                            className="target-input-box"
                                            type="text"
                                            defaultValue={value.note || "-"}
                                            onChange={event => {
                                                if (event && event.target && event.target.value) {
                                                    const updatedValues = this.state.updatedValues;
                                                    if (updatedValues) {
                                                        if (!updatedValues[value.id]) {
                                                            updatedValues[value.id] = {};
                                                        }
                                                        updatedValues[value.id].note = event.target.value;
                                                        this.setState({ updatedValues: updatedValues });
                                                    }
                                                }
                                                return;
                                            }}
                                        />
                                    </div>
                                    <span>
                                        {
                                            <button
                                                onClick={() =>
                                                    this.state.onClickOfTargetUpdate({ value, index, array })
                                                }>
                                                &#x2714;
                                            </button>
                                        }
                                    </span>
                                </Popup>
                            </td>

                            <td className="triggers-table-rows-target">
                                <span>{value.breakout}%</span>
                                <span>({value.dayChangePercentage}%)</span>
                            </td>
                        </tr>
                    </div>
                )),
            );
        }
        return (
            <div>
                <div>
                    <header>
                        <h1>Targets ({(this.state && this.state.targetsCount) || 0})</h1>
                    </header>
                </div>
                <div>
                    <header className="triggers-table">
                        <table>{getMappedTargetsResp}</table>
                    </header>
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Targets;
